import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import { useSelector } from "react-redux";
import { incidentService, propertyService } from "@iso/services";
import { INVESTIGATION_TYPES } from "@iso/constants/incidentOptions";

const { Option } = Select;
const { TextArea } = Input;

const ClassificationModal = ({ visible, incident, onCancel, onSaved, propertyId: propertyIdProp }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [propertyUsers, setPropertyUsers] = useState([]);
  const reduxPropertyId = useSelector((state) => state.property.activePropertyId);
  const activePropertyId = propertyIdProp || reduxPropertyId;

  useEffect(() => {
    if (visible && activePropertyId) {
      propertyService.getListUsersOfProperty(activePropertyId, true).then((res) => {
        if (res && res.users) {
          setPropertyUsers(res.users);
        }
      });
    }
  }, [visible, activePropertyId]);

  useEffect(() => {
    if (visible && incident) {
      form.setFieldsValue({
        classification: incident.classification || undefined,
        investigation_type: incident.investigation_type || undefined,
        investigator_id: incident.investigator_id || undefined,
        location_business_area: incident.location_business_area || undefined,
      });
    } else {
      form.resetFields();
    }
  }, [visible, incident, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await incidentService.classify(incident.id, values);
      message.success("Incident classified successfully.");
      onSaved && onSaved();
      onCancel();
    } catch (err) {
      if (err.errorFields) return; // validation error
      message.error(err?.response?.data?.message || "Failed to classify incident.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="Classify & Assign Investigation"
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
      okText="Classify"
      okButtonProps={{ style: { backgroundColor: '#0B2A1B', borderColor: '#0B2A1B' } }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="classification"
          label="Classification"
          rules={[{ required: true, whitespace: true, message: "Classification is required" }]}
        >
          <TextArea rows={2} placeholder="Enter classification details" />
        </Form.Item>

        <Form.Item
          name="investigation_type"
          label="Investigation Type"
          rules={[{ required: true, message: "Investigation type is required" }]}
        >
          <Select placeholder="Select investigation type">
            {INVESTIGATION_TYPES.map((t) => (
              <Option key={t.value} value={t.value}>
                {t.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) => prev.investigation_type !== cur.investigation_type}
        >
          {({ getFieldValue }) =>
            getFieldValue("investigation_type") &&
            getFieldValue("investigation_type") !== "notification_only" ? (
              <Form.Item name="investigator_id" label="Assign Investigator">
                <Select
                  placeholder="Select investigator"
                  showSearch
                  optionFilterProp="children"
                  allowClear
                >
                  {propertyUsers.map((u) => (
                    <Option key={u.id} value={u.id}>
                      {u.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            ) : null
          }
        </Form.Item>

        <Form.Item name="location_business_area" label="Location / Business Area">
          <Input placeholder="e.g. Horticulture, Processing" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ClassificationModal;
